import React from 'react';
import { Col } from 'react-bootstrap';

const FieldItem = ({ label, value }) => (
  <Col xs={6} md={4} className="mb-3">
    <div className="fw-semibold mb-1">{label}</div>
    <div>
      {value !== null && value !== undefined && value !== '' ? value : '-'}
    </div>
  </Col>
);

export default FieldItem;
